import React from 'react';
import PropTypes from 'prop-types';

import DateDataPod from '../../../components/DateDataPod';
import getDeadlineDisplayName, { getDeadlineTerm } from '../../../utils/deadline';
import get from 'lodash/get';

export default function Deadline({ type, month, day, description, term, featureFlags }) {
  if (!type || !month || !day) return null;

  const deadlinesImprovedRender = get(
    featureFlags,
    'featureDeadlinesImprovedRender',
    false,
  );

  let deadlineName = getDeadlineDisplayName({ type, description });
  let header = deadlinesImprovedRender ? 'Next Deadline' : deadlineName;

  const footerText = deadlinesImprovedRender
    ? [getDeadlineTerm({ term }), deadlineName]
    : [];

  let localMonth = month;

  if (typeof localMonth === 'string') {
    localMonth = Number(localMonth);
  }

  return (
    <DateDataPod
      header={header}
      ariaLabel={`${header}, month ${localMonth}, day ${day}`}
      content={{
        value: { month: localMonth - 1, day },
        linkText: 'See all deadlines',
        linkUrl: 'Admissions#application-info-deadlines',
        footerText,
      }}
    />
  );
}

Deadline.propTypes = {
  type: PropTypes.string,
  month: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  day: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
